export const MENU = {
  ROLE_ADMIN: [
    // ==========================================
    // DASHBOARD
    // ==========================================
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "🏠",
      permission: "DASHBOARD_VIEW",
    },

    // ==========================================
    // SALES
    // ==========================================
    {
      id: "sales",
      label: "Sales",
      icon: "🛒",
      permission: null,
      children: [
        {
          id: "sale",
          label: "Customer Invoice /SV",
          icon: "🧾",
          permission: "INVOICE_VIEW",
        },
        {
          id: "sreturns",
          label: "Sales Memo",
          icon: "↩️",
          permission: "INVOICE_VIEW",
        },
        {
          id: "salesReport",
          label: "Sales Report",
          icon: "📈",
          permission: "INVOICE_VIEW",
        },
      ],
    },

    // ==========================================
    // PURCHASES
    // ==========================================
    {
      id: "purchases",
      label: "Purchases",
      icon: "🛍️",
      permission: null,
      children: [
        {
          id: "purchase",
          label: "Supplier Invoice /GRV",
          icon: "📥",
          permission: "INVOICE_VIEW",
        },
        {
          id: "preturns",
          label: "Purchase Memo",
          icon: "🔄",
          permission: "INVOICE_VIEW",
        },
      ],
    },

    // ==========================================
    // INVENTORY
    // ==========================================
    {
      id: "inventory",
      label: "Inventory",
      icon: "📦",
      permission: null,
      children: [
        {
          id: "stockBalance",
          label: "Stock Balance",
          icon: "📊",
          permission: "INVENTORY_VIEW",
        },
        {
          id: "adjustment",
          label: "Stock Adjustments",
          icon: "⚖️",
          permission: "INVENTORY_VIEW",
        },
        {
          id: "expired",
          label: "Expired Items",
          icon: "⏳",
          permission: "INVENTORY_VIEW",
        },
      ],
    },

    // ==========================================
    // PARTNERS
    // ==========================================
    {
      id: "client",
      label: "Customers & Suppliers",
      icon: "🤝",
      permission: "CLIENT_VIEW",
    },

    // ==========================================
    // PAYMENTS
    // ==========================================
    {
      id: "Payments",
      label: "Payment & Withhold",
      icon: "💳",
      permission: null,
      children: [
        {
          id: "payment",
          label: "Payments & Reconciliation",
          icon: "💳",
          permission: "PAYMENT_VIEW",
        },
        {
          id: "withholdingLogs",
          label: "Withholds",
          icon: "📋",
          permission: "REPORT_VIEW", // or WITHHOLDING_VIEW if you have it
        },
      ],
    },
    // ==========================================
    // EXPENSES
    // ==========================================
    {
      id: "expenses",
      label: "Expenses",
      icon: "💸",
      permission: null,
      children: [
        {
          id: "expense",
          label: "Expense List",
          icon: "📝",
          permission: "EXPENSE_VIEW",
        },
        {
          id: "expenseCat",
          label: "Expense Categories",
          icon: "🏷️",
          permission: "EXPENSE_VIEW",
        },
      ],
    },

    // ==========================================
    // FIXED ASSETS
    // ==========================================
    {
      id: "asset",
      label: "Fixed Assets",
      icon: "🏭",
      permission: null,
      children: [
        {
          id: "fixedasset",
          label: "Asset Register",
          icon: "🏗️",
          permission: "PRODUCT_VIEW", // prefer ASSET_VIEW when available
        },
        {
          id: "assetCat",
          label: "Asset Categories",
          icon: "🗂️",
          permission: "CATEGORY_VIEW",
        },
      ],
    },

    // ==========================================
    // REPORTS & ACCOUNTING
    // ==========================================
    {
      id: "freports",
      label: "Financial Reports",
      icon: "📊",
      permission: null,
      children: [
        {
          id: "profit",
          label: "Profit & Loss",
          icon: "📈",
          permission: "REPORT_VIEW",
        },
        {
          id: "balance",
          label: "Balance Sheet",
          icon: "⚖️",
          permission: "REPORT_VIEW",
        },
        {
          id: "trial",
          label: "Trial Balance",
          icon: "🧾",
          permission: "REPORT_VIEW",
        },
        {
          id: "taxSummary",
          label: "Tax Summary",
          icon: "💰",
          permission: "REPORT_VIEW",
        },
        {
          id: "cash",
          label: "Cash Flow",
          icon: "💵",
          permission: "REPORT_VIEW",
        },
      ],
    },

    // ==========================================
    // HR & PAYROLL
    // ==========================================
    {
      id: "hr",
      label: "Office Administration",
      icon: "👥",
      permission: null,
      children: [
        {
          id: "employee",
          label: "Employees",
          icon: "👤",
          permission: "EMPLOYEE_VIEW",
        },
        {
          id: "payroll",
          label: "Payroll Runs",
          icon: "💵",
          permission: "PAYROLL_VIEW",
        },
        {
          id: "advance",
          label: "Salary Advances",
          icon: "💰",
          permission: "PAYROLL_VIEW",
        },
        {
          id: "department",
          label: "Departments",
          icon: "🏛️",
          permission: "CATEGORY_VIEW",
        },
        {
          id: "jobPosition",
          label: "Job Positions",
          icon: "💼",
          permission: "CATEGORY_VIEW",
        },
        {
          id: "letterManagement",
          label: "Memo",
          icon: "📝",
          permission: "LETTER_VIEW",
        },
      ],
    },
    // ==========================================
    // ADMINISTRATION
    // ==========================================
    {
      id: "administration",
      label: "Settings",
      icon: "⚙️",
      permission: null,
      children: [
        {
          id: "tenantSetting",
          label: "Business Settings",
          icon: "🛠️",
          permission: "TENANT_UPDATE",
        },
        {
          id: "fiscalYear",
          label: "Fiscal Years",
          icon: "📅",
          permission: "FISCAL_YEAR",
        },
        {
          id: "group-products",
          label: "Product Setup",
          icon: "📦",
          permission: null,
          children: [
            {
              id: "product",
              label: "Products",
              icon: "📋",
              permission: "PRODUCT_VIEW",
            },
            {
              id: "productCategory",
              label: "Categories",
              icon: "🏷️",
              permission: "CATEGORY_VIEW",
            },
            {
              id: "unit",
              label: "Units of Measure",
              icon: "📏",
              permission: "PRODUCT_VIEW",
            },
          ],
        },
        {
          id: "payrollSetup",
          label: "Payroll Setup",
          icon: "🧩",
          permission: null,
          children: [
            {
              id: "salaryStructure",
              label: "Salary Structures",
              icon: "📂",
              permission: "CATEGORY_VIEW",
            },
            {
              id: "payrollComponnt",
              label: "Salary Components",
              icon: "🧱",
              permission: "CATEGORY_VIEW",
            },
          ],
        },
        {
          id: "user",
          label: "Users",
          icon: "👤",
          permission: "USER_VIEW",
        },
        {
          id: "role",
          label: "Roles & Permissions",
          icon: "🛡️",
          permission: "ROLE_VIEW",
        },
        {
          id: "branch",
          label: "Branches",
          icon: "🏪",
          permission: "BRANCH_VIEW",
        },
        {
          id: "subscriptionBilling",
          label: "Subscription",
          icon: "💎",
          permission: "BRANCH_VIEW",
        },
        {
          id: "backup",
          label: "Backup & Export",
          icon: "💾",
          permission: "FISCAL_YEAR",
        },
        {
          id: "deactivate",
          label: "Deactivate Account",
          icon: "🚫",
          permission: "TENANT_DELETE",
        },
      ],
    },
  ],
};

export default MENU;
